export default "__VITE_ASSET__CMZu817$__"